import React from 'react';
//import DistribucionLimitesCuentaActions from '../actions/DistribucionLimitesCuentaActions';
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableHeader = React.createClass({

    onChangeCuentas: function (event) {
        this.props.seleccionDeEmpresa(event.target.value);
    },

    createRow(Empresa, admId, idEmp, setAccId, empresasSuperadasDeLimite) {
        let denom = Empresa.Descripcion + " (" + Empresa.tipoCuentaDescripcion + ")";
        let empresa
        if (empresasSuperadasDeLimite !== undefined && empresasSuperadasDeLimite.lenght > 0) {
            empresa = empresasSuperadasDeLimite.find(x => x == idEmp);
        }
        
        if (Empresa.AdministradoraId === admId || Empresa.esNueva) {
            if (Empresa.Id == idEmp) {
                return (<GenericOption id={Empresa.Id} description={denom} selected={"selected"} key={"EmpresaOP_" + Empresa.Id} />);
            }
            else {
                if (Empresa.Id == setAccId) {
                    return (<GenericOption id={Empresa.Id} description={denom} selected={"selected"} key={"EmpresaOP_" + Empresa.Id} />);
                }
                else {
                    return (<GenericOption id={Empresa.Id} description={denom} key={"EmpresaOP_" + Empresa.Id} />);
                }
            }
        }
    },

    render: function () {
        let data = this.props.data;
        let acc;
        let idEmp;
        let setAccId;
        let mapRow = [];
        let valorLimiteEmpresa;
        let valorLimiteCuenta;
        let i = 0;
        let admId = parseInt(data.administradoraSeleccionadaId);
        let functions = this.props.data.functions;
        let me = this;
        let oCuentas = [];
        let valorLimiteEmpresaFormato = 0;
        let empresas = this.props.data.empresas;
        let cuentas = this.props.data.cuentas;

        let limiteClienteFormato = GlobalHelper.ConvertirNumeroSinDecimales(this.props.limitesCliente.LimitePorCuit);
        let empresaSeleccionada = empresas.find(x => x.Id == this.props.data.selectEnterpriseId)
        if (empresaSeleccionada == undefined)
        empresaSeleccionada = empresas[0];
        if (empresaSeleccionada != undefined) {
            idEmp = empresaSeleccionada.Id;
            let novedadEmpresa = this.props.data.novedadesEmpresas.find(x => x.EmpresaId == idEmp);
            if (novedadEmpresa == undefined)
            valorLimiteEmpresa = empresaSeleccionada.LimiteCompra;
            else
            valorLimiteEmpresa = novedadEmpresa.ValorNovedad;
            
            let cuentaSeleccionada = cuentas.find(x => x.Id == this.props.data.selectCuentasId)
            if (cuentaSeleccionada == undefined) {
                cuentaSeleccionada = cuentas.find(x => x.EmpresaId == idEmp);
                
                if (cuentaSeleccionada == undefined) {
                    cuentaSeleccionada = cuentas.find(x => x.EmpresaVisaId == idEmp);
                }
            }             
            
            valorLimiteEmpresaFormato = GlobalHelper.ConvertirNumeroSinDecimales(valorLimiteEmpresa);
            
            if (cuentaSeleccionada != undefined) {
                setAccId = cuentaSeleccionada.Id;
                
                let novedadCuenta = this.props.data.novedadesCuentas.find(x => x.CuentaTarjetaId == setAccId);
                if (novedadCuenta == undefined)
                valorLimiteCuenta = cuentaSeleccionada.Valor;
                else
                valorLimiteCuenta = novedadCuenta.ValorNovedad;
                
            }
            let empresasSuperadasDeLimite = this.props.data.limiteCuentaExcedido
            if (functions.Confidencial == true || Cuentas.esNueva) {
                oCuentas = data.empresas.map(function (Cuentas) {
                    return me.createRow(Cuentas, admId, idEmp, empresasSuperadasDeLimite);
                });
            }
            else {
                oCuentas = data.empresas.map(function (Cuentas) {
                    if (Cuentas.EsConfidencial == false) {
                        return me.createRow(Cuentas, admId, idEmp, empresasSuperadasDeLimite);
                    }
                    else {
                        return null;
                    }
                });
            }
            
            oCuentas.map(function (row) {
                if (oCuentas[i] != undefined) {
                    mapRow.push(oCuentas[i]);
                }
                i += 1;
            });
        }
        
        if (mapRow[0] != undefined) {
            acc = <div className="row">
                <div className="col-md-6">
                    <label className="label-secondary color-black">${valorLimiteEmpresaFormato}</label>
                </div>
            </div>
        }
        else {
            acc = <div className="row">
                <div className="col-md-1">
                </div>
                <div className="col-md-11">
                    <label className="label-primary">Aun no existen cuentas para ésta administradora</label>
                </div>
            </div>
        }
               
        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <label className="label-secondary">Límite global para {data.selectedAdministrator}:</label>
                    </div>
                    <div className="col-md-6">
                        <label className="label-secondary color-black">${limiteClienteFormato}</label>
                    </div>
                </div>
                <div className="col-md-1">
                </div>
                <div className="col-md-5">
                    <div className="row">
                        <div className="col-md-3">
                            <label className="label-secondary">Límite de</label>
                        </div>
                        <div className="col-md-9">
                            <GenericSelect id="selCuentas" className="form-control default-select bottom-separator-xs error" options={mapRow} onChange={this.onChangeCuentas} />
                        </div>
                    </div>
                </div>
                {acc}
            </div>
        );
    },
});

export default TableHeader